import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { RoleListIdCell } from './role-list-id.cell';
import { RoleListIdHeader } from './role-list-id.header';

export const RoleListIdColumn: IdentifiedColumnDef<
  GatewayRoleModel,
  GatewayRoleModel['id']
> = {
  enableSorting: false,
  header: RoleListIdHeader,
  cell: RoleListIdCell,
};
